import type { ReactNode } from 'react';

import { Card, CardContent, CardHeader } from '../../../ui/card';

/** The card every reading sits in, so its loading and error states keep the
 *  frame and the title. `icon` sits before the title, in the same flex item,
 *  so a multi-child header's `justify-between` still puts `aside` on the far
 *  side rather than splitting three ways. */
export function Frame(props: {
  title: string;
  icon?: ReactNode;
  aside?: ReactNode;
  children: ReactNode;
}): ReactNode {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between gap-2">
        <span className="flex items-center gap-2">
          {props.icon}
          <h2 className="text-title-md">{props.title}</h2>
        </span>
        {props.aside}
      </CardHeader>
      <CardContent className="flex flex-col gap-4">{props.children}</CardContent>
    </Card>
  );
}
